module.exports = __webpack_public_path__ + "static/media/s4g_invite.d2280c16.jpg";